import type { IAPI } from '../../apiResponse';
import { getRequest } from '../../httpClient';
import {
  getPublicChallengesByTypeV1ResponseSchema,
  type IGetPublicChallengesByTypeV1ResponseData,
} from './get-public-challenges-by-type-v1-response';

export async function getPublicChallengesByTypeV1Api(type: string) {
  return getRequest<IAPI<IGetPublicChallengesByTypeV1ResponseData>>({
    path: `/challenges/type/${encodeURIComponent(type)}/v1`,
    schema: getPublicChallengesByTypeV1ResponseSchema,
  });
}
